module.exports = __webpack_public_path__ + "media/video-1.9128dc9d.mp4";